import { createStyles, Grid, makeStyles, Theme } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import React from 'react';
import { connect } from 'react-redux';
import { APIConstants } from '../../utils/api/constants';
import { APIState } from '../../utils/api/reducer';
import { Player } from '../store/types';

const useStyles = makeStyles((theme: Theme) => createStyles({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontFamily: 'Roboto',
  },
  wrapper: {
    maxWidth: 542,
  },
  value: {
    backgroundColor: theme.palette.common.white,
    padding: '4px 8px',
    fontSize: 24,
    borderRadius: 8,
    [theme.breakpoints.down('xs')]: {
      fontSize: 16,
      padding: 4,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
  },
  green: {
    backgroundColor: theme.palette.success.main,
  },
  header: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
    display: 'flex',
    alignItems: 'center',
    padding: '4px 8px',
    borderRadius: 8,
    fontSize: 24,
    [theme.breakpoints.down('xs')]: {
      fontSize: 20,
      padding: 4,
    },
  },
}));

interface ReduxProps {
  readonly compareResults: APIState<Player[]>;
}

type Props = ReduxProps;

const Rating = (props: Props) => {
  const classes = useStyles();
  const { compareResults } = props;
  return (
    <div className={classes.root}>
      <Grid container className={classes.wrapper}>
        <Grid container item xs={3} justifyContent="center">
          <div className={`${classes.value} ${compareResults?.data[0]?.headToHead?.highlight ? classes.green : ''}`}>
            {
              compareResults.status === APIConstants.SUCCEEDED && (
                compareResults?.data[0].headToHead.value
              )
            }
            {
              compareResults.status !== APIConstants.SUCCEEDED && (
                <Skeleton variant='rect'  height={40} width={50} />
              )
            }
          </div>
        </Grid>
        <Grid container item xs={6} justifyContent="center">
          <div className={classes.header}>
            Head-To-Head
          </div>
        </Grid>
        <Grid container item xs={3} justifyContent="center">
          <div className={`${classes.value} ${compareResults?.data[1]?.headToHead?.highlight ? classes.green : ''}`}>
            {
              compareResults.status === APIConstants.SUCCEEDED && (
                compareResults?.data[1].headToHead.value
              )
            }
            {
              compareResults.status !== APIConstants.SUCCEEDED && (
                <Skeleton variant='rect'  height={40} width={50} />
              )
            }
          </div>
        </Grid>
      </Grid>
    </div>
  )
};

const mapStateToProps = (state: any) => {
  const {
    compareResults
  } = state.playerCompare;
  return {
    compareResults
  };
};

export default connect(mapStateToProps, {})(Rating);